import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AuthContextProvider } from './contexts/AuthContext';
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { AdminRoom } from "./pages/AdminRoom";
import { Home } from "./pages/Home";
import { NewRoom } from "./pages/NewRoom";
import { Room } from "./pages/Room";
import { AuthRoute } from "./AuthRoute";
import { NotFound } from "./pages/NotFound";

function App() {

  return (
    <BrowserRouter>
      <ThemeContextProvider>
        <AuthContextProvider>
          <Switch>
            <Route path="/" exact component={Home} />
            <AuthRoute path="/rooms/new" component={NewRoom} />
            <Route path="/rooms/:id" component={Room} />
            <AuthRoute path="/admin/rooms/:id" component={AdminRoom} />
            <Route path="*" component={NotFound} />
          </Switch>
        </AuthContextProvider>
      </ThemeContextProvider>
    </BrowserRouter>
  );
}

export default App;
